import { render, staticRenderFns } from "./CustomerViewPlanCard.vue?vue&type=template&id=0dc6ef57"
import script from "./CustomerViewPlanCard.vue?vue&type=script&lang=js"
export * from "./CustomerViewPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports